// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container.fill-height > .row {\n  flex: 1 1 100%;\n  max-width: calc(100%) !important;\n}\n.cursor-pointer {\n  cursor: pointer;\n}\n.v-card--link:focus:before {\n  opacity: 0 !important;\n}\n.v-toolbar__content {\n  z-index: 10002 !important;\n}\n.required label::after {\n  content: ' *';\n  color: red;\n}\n", ""]);
// Exports
module.exports = exports;
